import script from "./ModalPermisosCirculares.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPermisosCirculares.vue?vue&type=script&setup=true&lang=js"

import "./ModalPermisosCirculares.vue?vue&type=style&index=0&id=497066c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497066c0"]])

export default __exports__